export { default } from './StaticPageFirstSection';
export { firstSectionItems } from './StaticPageFirstSection.consts';
export type { Item } from './StaticPageFirstSection.types';
